import { useEffect, useState } from "react"

// QUERIES
// import { KURSIST_COUNT, UPDATE_KURSISTER, GET_KURSISTER } from '../../../../queries/kursister.gql'
import { HOLD_COUNT, UPDATE_MULTIPLE_HOLD, GET_HOLD } from '../../../../queries/hold.gql'
import { CREATE_KURSUS, UPDATE_KURSUS, DELETE_KURSUS } from '../../../../queries/catalogs/kurser.gql'
import { ALL_CATALOGS } from '../../../../queries/catalogs/allCatalogs.gql'

// HOOKS
import { useCatalog } from "../../../../hooks/useCatalog"

// COMPONENTS
import { AdminInterfaceTemplate } from "../AdminInterfaceTemplate/AdminInterfaceTemplate"
import CheckboxInput from "../../../Inputs/CheckboxInput/CheckboxInput"
import Input from "../../../Inputs/Input"

let lastData = [] 
let changeTimeStamp = new Date().valueOf();
const primaryKey = "Kursus_id"

export default function AdminInterfaceKurser() {
    const catalogs = useCatalog()
    const content = catalogs.kurser

    const [newContent, setNewContent] = useState(content)
    const [searchString, setSearchString] = useState("")
    const [sort, setSort] = useState({field: "", dir: false})
    const [selected, setSelected] = useState(null)
    const [newObj, setNewObj] = useState(null)
    const [scrollToBottom, setScrollToBottom] = useState(false)
    const [customLoading, setCustomLoading] = useState(false)

    useEffect(() => {
        const filtered = AdminInterfaceTemplate.functions
        .localSearch(searchString, content, ["Kursus"])
        setNewContent(filtered)
    },[searchString])

    useEffect(() => {
        const sorted = AdminInterfaceTemplate.functions.localSort(newContent, sort)
        setNewContent(sorted)
    },[sort])

    useEffect(() => {
        if (customLoading)
            setCustomLoading(false)

        if (sort.field) {
            const sorted = AdminInterfaceTemplate.functions.localSort(content, sort)
            setNewContent(sorted)
        } else {
            setNewContent(content)
        }
        if (content.toString() != lastData.toString()) {
            changeTimeStamp = new Date().valueOf();
            lastData = content
        }
    },[content])

    const event = {
        search: (name, val) => {
            setSearchString(val)
        },
        sort: (field) => {
            setSort({field: field, dir: !sort.dir})
        },
        rowClick: (val, index) => {
            setNewObj(null)
            setSelected(val)
        },
        UpdateInput: (name, val) => {
            let updateObj = {...selected}
            updateObj[name] = val
            setSelected(updateObj)
        },
        createInput: (name, val) => {
            let updateObj = {...newObj}
            updateObj[name] = val
            setNewObj(updateObj)
        },
        new: () => {
            setSelected(null)
            setNewObj({
                Kursus: "",
                Aktivt: false,
                E_learning: false
            })
        },
        createSuccess: (res) => {
            setSearchString("")
            setSelected(res)
            setScrollToBottom(true)
        },
        createStart: () => {
            setCustomLoading(true)
        },
        updateSuccess: (id) => {
            setSearchString("")
            setCustomLoading(false)
        },
        updateStart: () => {
            setCustomLoading(true)
        },
        deleteStart: () => {
            const htmlRow = document.querySelector(`[data-primary-key="${primaryKey}${selected[primaryKey]}"]`)
            htmlRow.classList.add("inactive_load")
            setCustomLoading(true)
        },
        deleteSuccess: () => {
            setSearchString("")
            setSelected(null)
            setNewObj(null)
        },
        moveStart: () => {
            setCustomLoading(true)
        },
        moveSuccess: () => {
            setSearchString("")
            setCustomLoading(false)
        }
    }

    return (
        <AdminInterfaceTemplate.component>
            <AdminInterfaceTemplate.content>
                <AdminInterfaceTemplate.table 
                    primaryKey={primaryKey}
                    changeTimeStamp={changeTimeStamp}
                    scrollToBottom={scrollToBottom}
                    setScrollToBottom={setScrollToBottom}
                    onNew={event.new}
                    searchFunction={event.search}
                    searchString={searchString}
                    content={newContent}
                    selected={selected}
                    rowClick={event.rowClick}
                    rowSelect={!selected ? null : {field: primaryKey, value: selected.Kursus_id}}
                    cells={[
                        {
                            size: 0,
                            title: "ID",
                            name: "Kursus_id",
                            sort: sort,
                            onClick: () => event.sort("Kursus_id")
                        },
                        {
                            size: 1,
                            title: "Kursus",
                            name: "Kursus",
                            sort: sort,
                            onClick: () => event.sort("Kursus")
                        },
                        {
                            size: 0,
                            title: "E-learning",
                            name: "E_learning",
                            sort: sort,
                            onClick: () => event.sort("E_learning")
                        },
                        {
                            size: 0,
                            title: "Aktiv",
                            name: "Aktivt",
                            sort: sort,
                            onClick: () => event.sort("Aktivt")
                        }
                    ]}
                />
                {selected ? 
                    <AdminInterfaceTemplate.update
                        variables={{
                            id: selected.Kursus_id,
                            input: {
                                Kursus: selected.Kursus,
                                Aktivt: selected.Aktivt,
                                E_learning: selected.E_learning
                            }
                        }}
                        updateQuery={UPDATE_KURSUS}
                        deleteQuery={DELETE_KURSUS}
                        refetchQueries={[ALL_CATALOGS]}
                        title={selected.Kursus}
                        id={selected.Kursus_id}
                        countQueryObj={{
                            query: HOLD_COUNT,
                            variables: {
                                conditions: {
                                    Kursus_id: selected.Kursus_id
                                }
                            },
                            loading: "Checkker Kursus...",
                            warning: "{{count}} hold med {{title}}, Sletning er ikke opfordret!",
                            goTo: {
                                text: "Find holdende",
                                path: "/hold",
                                value: `Kursus_id=${selected.Kursus_id}`
                            },
                            move: {
                                query: UPDATE_MULTIPLE_HOLD,
                                variables: {
                                    field: `Kursus_id`,
                                    from: selected.Kursus_id,
                                    title: selected.Kursus
                                },
                                refetchQueries: [GET_HOLD, HOLD_COUNT, ALL_CATALOGS],
                                onMoveStart: event.moveStart,
                                onMoveSuccess: event.moveSuccess,
                                text: "Skift kurset på holdet",
                                menuText: "Skift kurset for {{count}} hold?",
                                selectOptions: content.map(obj => ({value: obj.Kursus_id, title: obj.Kursus})),
                            },
                            delete: {
                                text: "Handlingen vil forsøge at nulstille kursus værdierne for {{count}} hold, er du sikker på du ikke vil ændre kursus værdierne først?"
                            }
                        }}
                        customLoading={customLoading}
                        onUpdateStart={event.updateStart}
                        onUpdateSuccess={event.updateSuccess}
                        onDeleteStart={event.deleteStart}
                        onDeleteSuccess={event.deleteSuccess}
                    >
                        <Input 
                            label="Kursus" 
                            name="Kursus" 
                            value={selected.Kursus} 
                            onInput={event.UpdateInput} 
                        />
                        <CheckboxInput 
                            label="E-learning"
                            name="E_learning"
                            value={selected.E_learning}
                            onInput={event.UpdateInput} 
                        />
                        <CheckboxInput 
                            label="Aktiv"
                            name="Aktivt"
                            value={selected.Aktivt}
                            onInput={event.UpdateInput} 
                        />
                    </AdminInterfaceTemplate.update>
                : newObj ?
                    <AdminInterfaceTemplate.create
                        variables={{
                            input: {...newObj}
                        }}
                        createQuery={CREATE_KURSUS}
                        refetchQuery={ALL_CATALOGS}
                        customLoading={customLoading}
                        onCreateSuccess={event.createSuccess}
                        onCreateStart={event.createStart}
                    >
                        <Input 
                            label="Kursus" 
                            name="Kursus" 
                            value={newObj.Kursus} 
                            onInput={event.createInput} 
                        />
                        <CheckboxInput 
                            label="E-learning"
                            name="E_learning"
                            value={newObj.E_learning}
                            onInput={event.createInput} 
                        />
                        <CheckboxInput 
                            label="Aktiv"
                            name="Aktivt"
                            value={newObj.Aktivt}
                            onInput={event.createInput} 
                        />
                    </AdminInterfaceTemplate.create>
                : <AdminInterfaceTemplate.empty />}

            </AdminInterfaceTemplate.content>
        </AdminInterfaceTemplate.component>
    )
}
